/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP6_ANSWERS = [
    'Tony, Howard, and Bethany are in the kitchen.',
    'Bethany brings some vanilla ice cream for dessert.',
    'Howard and Tony think vanilla is boring!',
    'Bethany says they can make it interesting.',
    'So, they put cookies, strawberries, and blueberries in their ice cream.',
    'Next, they add maple syrup, pretzels, and nuts, too.',
    'Then, Tony sees some chocolate peanuts. Howard tries to open the bag. But it’s tough to open.',
    'Howard tries to open the bag.',
    'But it’s tough to open.',
    'Howard pulls the bag really hard and it rips!',
    'Chocolate peanuts spill all over the floor!',
    'So, Bethany gets the chocolate chips.',
    'The family put on lots of toppings. They can’t see their ice cream anymore!',
    'They can’t see their ice cream anymore!',
    'Bethany and Tony are eating ice cream outside an ice-cream shop.',
    'A TV producer sees Tony.',
    'He wants Tony to be in a TV show!',
    'In the TV show, Tony has to eat ice cream.',
    'The TV producer is happy with Tony’s acting.',
    'And Tony is happy eating ice cream!',
];

// export const HHT1_EP6_ANSWER_SOUNDS = [
//     '/1_EP06_SB_TL_01.mp3',
//     '/1_EP06_SB_TL_02.mp3',
//     '/1_EP06_SB_TL_03.mp3',
//     '/1_EP06_SB_TL_04.mp3',
//     '/1_EP06_SB_TL_05.mp3',
//     '/1_EP06_SB_TL_06.mp3',
//     '/1_EP06_SB_TL_07.mp3',
//     '/1_EP06_SB_TL_08.mp3',
//     '/1_EP06_SB_TL_09.mp3',
//     '/1_EP06_SB_TL_10.mp3',
//     '/1_EP06_SB_TL_11.mp3',
//     '/1_EP06_SB_TL_12.mp3',
//     '/1_EP06_SB_TL_13.mp3',
//     '/1_EP06_SB_TL_14.mp3',
//     '/1_EP06_SB_TL_15.mp3',
//     '/1_EP06_SB_TL_16.mp3',
//     '/1_EP06_SB_TL_17.mp3',
//     '/1_EP06_SB_TL_18.mp3',
//     '/1_EP06_SB_TL_19.mp3',
//     '/1_EP06_SB_TL_20.mp3',
//     '/1_EP06_SB_TL_21.mp3',
//     '/1_EP06_SB_TL_22.mp3',
//     '/1_EP06_SB_TL_23.mp3',
//     '/1_EP06_SB_TL_24.mp3',
//     '/1_EP06_SB_TL_25.mp3',
//     '/1_EP06_SB_TL_26.mp3',
// ];

export const HHT1_EP6_ANSWER_SOUNDS = [
    '/9c48fb80e86b71ed4f3532c34d3d0e8e.mp3',
    '/35a62910d3881212e194cb32f61090b0.mp3',
    '/4fdfed909c4e7577741c8b360e8932a7.mp3',
    '/9ed4be29abeaaf9db34ab7a172d5a314.mp3',
    '/d63f3bad396c2365e20a4c209c51bd03.mp3',
    '/4d8376c0502b118f76c05509cdd209a0.mp3',
    '/d3846a33580228a379ef6eb594b4a356.mp3',
    '/9616cfc86d9c8cdbaf1897f3ebe42bb9.mp3',
    '/987c86ba193667b8459a7632e8ecd4d8.mp3',
    '/d2c3908086be0c3f0bcbfd30a11fedce.mp3',
    '/f9f9cc6c639a74f257ddb66af36e5960.mp3',
    '/b8647fbf0698f12d5f30199e6902acb8.mp3',
    '/8e50f054103f002960305a9326f304ef.mp3',
    '/a13b74c9f07b566a07deeb03876111c1.mp3',
    '/76e5c936cccb3b33882edb7effd027ac.mp3',
    '/51bf154387edc35c98c0596735784418.mp3',
    '/060735e2c7c6b9c0b446938069a11c33.mp3',
    '/03e3afecdafec506bfa462899ce9ff22.mp3',
    '/cd3737e0fd4308775b8a13309d38c714.mp3',
    '/0e99fdb8094173082076458fbeaebe8f.mp3',
    '/f968f11ceef5bddfa12cb71f89f23dd8.mp3',
    '/5058eef9a81b419584cddbc3804b2565.mp3',
    '/2db3c317036111cafab9270999c38f76.mp3',
    '/d85215cb9246b76b7ca308bba38e8276.mp3',
    '/0d0adb814b5157ba407c5244e8bffa14.mp3',
    '/5b3d4df385dfd1188bce73601e068fe1.mp3',
];

export const HHT1_EP6_QUIZ_ITEMS = [{
    'A': HHT1_EP6_ANSWERS[14],
    'B': HHT1_EP6_ANSWERS[1],
    'SoundIndexA': 14,
    'SoundIndexB': 1,
    'answer': HHT1_EP6_ANSWERS[1],
    'sound': [20],
    'exception': false,
},
    {
        'A': HHT1_EP6_ANSWERS[4],
        'B': HHT1_EP6_ANSWERS[18],
        'SoundIndexA': 4,
        'SoundIndexB': 18,
        'answer': HHT1_EP6_ANSWERS[4],
        'sound': [5],
        'exception': false,
    },
    {
        'A': HHT1_EP6_ANSWERS[0],
        'B': HHT1_EP6_ANSWERS[6],
        'SoundIndexA': 0,
        'SoundIndexB': 24,
        'answer': HHT1_EP6_ANSWERS[6],
        'sound': [21, 11],
        'exception': false,
    },
    {
        'A': HHT1_EP6_ANSWERS[12],
        'B': HHT1_EP6_ANSWERS[15],
        'SoundIndexA': 25,
        'SoundIndexB': 15,
        'answer': HHT1_EP6_ANSWERS[12],
        'sound': [14, 22],
        'exception': true,
    },
    {
        'A': HHT1_EP6_ANSWERS[5],
        'B': HHT1_EP6_ANSWERS[17],
        'SoundIndexA': 5,
        'SoundIndexB': 17,
        'answer': HHT1_EP6_ANSWERS[17],
        'sound': [23],
        'exception': false,
    },

]
